import styled from 'styled-components';
import {getSpacing, getToken, getPrimitive, getFontWeight, getFontSize} from '@tickchak/react-share/app';
import {mobileMedia} from '../../../../globalVariables/GlobalVariables';
import zIndex from '../../../../globalVariables/zIndex';
import {dFlexCenter} from '../../../../globalVariables/GlobalFlex';

export type BadgeVariant = 'error' | 'warning' | 'success';

const BADGE_VARIANTS: Record<BadgeVariant, {color: string}> = {
    error: {
        color: getToken('color.state.error.main')
    },
    warning: {
        color: getToken('color.state.warning.main')
    },
    success: {
        color: getToken('color.state.success.bg')
    }
};

export const badge = styled.div<{variant: BadgeVariant}>`
    position: relative;
    ${dFlexCenter};
    gap: ${getSpacing('spaceSm')};
    padding: ${getSpacing('spaceSm')} ${getSpacing('spaceMd')};
    border-radius: var(--border-radius-border-radius-full);
    font-weight: ${getFontWeight('bold')};
    z-index: ${zIndex.baseRaised};
    width: max-content;
    height: max-content;
    margin-bottom: ${getSpacing('spaceMd')};
    border: 1px solid ${p => BADGE_VARIANTS[p.variant].color};
    color: ${p => BADGE_VARIANTS[p.variant].color};
    ${p => (p.theme?.rtl && p.theme.direction === 'ltr') || (!p.theme?.rtl && p.theme.direction === 'rtl') ? 'inset-inline-end' : 'inset-inline-start'}: 0px;

    ${mobileMedia} {
        padding: 6px 12px;
        font-size: 12px;
    }
`;

export const badgeText = styled.span<{variant: BadgeVariant}>`
    white-space: nowrap;
    color: ${p => BADGE_VARIANTS[p.variant].color};
`;

export const badgeCounter = styled.span<{variant: BadgeVariant}>`
    ${dFlexCenter};
    gap: 2px;
    white-space: nowrap;
    color: ${p => BADGE_VARIANTS[p.variant].color};
`;

export const badgeIcon = styled.span<{variant: BadgeVariant}>`
    ${dFlexCenter};
    width: 20px;
    height: 20px;
    border-radius: 50%;
    font-weight: ${getFontWeight('bold')};
    font-size: ${getFontSize('caption')};
    flex-shrink: 0;
    background-color: ${p => BADGE_VARIANTS[p.variant].color};
    color: ${getPrimitive('color.bg.surface.default')};
`;
